import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AvailableWritingTools from "./sections/AvailableWritingTools";
import WhyLeadersUseArmyWritingTools from "./sections/WhyLeadersUseArmyWritingTools";
import HowArmyWritingToolsWorks from "./sections/HowArmyWritingToolsWorks";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AvailableWritingTools />
      <WhyLeadersUseArmyWritingTools />
      <HowArmyWritingToolsWorks />
      <Footer />
    </div>;
}